<template>
  <div id="hoursStatistical" class="container">
    <div class="header">
      <el-menu :default-active="listQuery.status" mode="horizontal" active-text-color="var(--theme-color)" @select="handleTabClick">
        <el-menu-item index="2">图表</el-menu-item>
        <el-menu-item index="1">列表</el-menu-item>
      </el-menu>
    </div>

    <div class="contentBox">
      <div v-show="listQuery.status == '2'" class="content">
        <el-row class="search-pane">
          <div class="iB">
            <label>项目名称：</label>
            <el-input v-model="listQuery.prjNameList" class="mr30" readonly size="small" style="width:220px" placeholder="请选择" :title="listQuery.prjNameList" @focus="openPrjDlg" />
            <label class="label">部门名称：</label>
            <el-cascader
              v-model="listQuery.deptIdList"
              style="width:220px"
              size="small"
              :options="depOptions"
              :props="depDefaultProps"
              collapse-tags
              clearable>
            </el-cascader>
            <label class="label">选择时间：</label>
            <el-date-picker v-model="listQuery.checkedDate" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              size="small" @change="timeSlot"></el-date-picker>
            <el-button plain style="margin-left: 10px;" size="small" @click="handleRefresh()">重置</el-button>
            <el-button type="primary" size="small" @click="handleSieve()">查询</el-button>
          </div>
        </el-row>
        <div class="charts-list">
          <div class="charts-item">
            <div id="myChart1" ref="myChart1"></div>
            <div class="charts-title">
              项目工作时长
            </div>
          </div>
          <div class="charts-item">
            <div id="myChart2" ref="myChart2"></div>
            <div class="charts-title">人员工作时长</div>
          </div>
          <div class="charts-item">
            <div id="myChart3" ref="myChart3"></div>
            <div class="charts-title">项目总人数</div>
          </div>
        </div>
      </div>
      <div v-show="listQuery.status == '1'" class="content">
        <el-row class="search-pane">
          <div>
            <div style="margin-bottom:var(--middle-space);">
              <el-radio-group v-model="tabPosition" size="small" @change="changeTabPosition">
                <el-radio-button label="已提交">已提交</el-radio-button>
                <el-radio-button label="未提交">未提交</el-radio-button>
              </el-radio-group>
            </div>
            <div v-if="tabPosition==='已提交'">
              <label>项目名称：</label>
              <el-input v-model="listQuery.prjNameList" class="mr30" readonly size="small" style="width:220px" placeholder="请选择" :title="listQuery.prjNameList" @focus="openPrjDlg" />
              <label class="label">部门名称：</label>
              <el-cascader
                v-model="listQuery.deptIdList"
                style="width:220px"
                size="small"
                :options="depOptions"
                :props="depDefaultProps"
                clearable>
              </el-cascader>
              <label class="label">选择姓名：</label>
              <el-select v-model="listQuery.checkedUser" size="small" class="mr30" filterable placeholder="请选择">
                <el-option v-for="item in usersList" :key="item.userID" :label="item.userName" :value="item.userName">
                </el-option>
              </el-select>
              <label style="margin-left: 10px;">选择时间：</label>
              <el-date-picker v-model="listQuery.checkedDate" size="small" type="daterange" align="right" unlink-panels
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                @change="timeSlot"></el-date-picker>
              <el-button type="primary" style="margin-left: 10px;" size="small" @click="handleSieve(true)">查询</el-button>
              <el-button plain size="small" @click="handleRefresh()">重置</el-button>
              <el-button type="primary" size="small" plain @click="exportOffice()">导出</el-button>
            </div>
            <div v-if="tabPosition==='未提交'">
              <label class="label">部门名称：</label>
              <el-cascader
                v-model="unSubmitQuery.deptIdList"
                style="width:220px"
                size="small"
                :options="depOptions"
                :props="depDefaultProps"
                clearable>
              </el-cascader>
              <label class="label">选择时间：</label>
              <el-date-picker v-model="unSubmitQuery.checkedDate" class="mr10" type="daterange" align="right"
                unlink-panels value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" size="small" @change="timeSlot" />
              <label class="label" style>包含周六日：</label>
              <el-radio-group v-model="unSubmitQuery.isWeekend" class="mr10">
                <el-radio label="0">包含</el-radio>
                <el-radio label="1">不包含</el-radio>
              </el-radio-group>
              <el-button style="margin: 0 10px" size="small" type="primary" @click="handleSieve(true)">查询</el-button>
              <el-button size="small" plain style="margin-left: 0;" @click="handleRefresh()">重置</el-button>
            </div>
          </div>
        </el-row>
        <div v-if="tabPosition==='已提交'" class="table-tree">
          <el-table :key="'已提交'" class="table-pane" height="100%" :data="hoursList" border
            :default-sort="{prop: 'userName', order: 'descending'}">
            <el-table-column type="index" width="80" label="序号" align="left"></el-table-column>
            <el-table-column prop="userName" label="姓名" sortable>
              <template #default="{ row }">
                <el-link type="primary" @click="viewdetail(row)">
                  <span class="tabLinkSpan" :title="row.userName">{{ row.userName }}</span>
                </el-link>
              </template>
            </el-table-column>
            <el-table-column prop="projectInfo" label="部门"></el-table-column>
            <el-table-column label="工作时长(小时)">
              <template slot-scope="scope">
                <span>{{ scope.row.workTimeSum }}</span>
              </template>
            </el-table-column>
            <el-table-column label="加班时长(小时)">
              <template slot-scope="scope">
                <span>{{ scope.row.overTimeSum }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="itemInfo" label="所属项目"></el-table-column>
          </el-table>
        </div>
        <div v-if="tabPosition==='已提交'" class="page-handler">
          <pagination v-show="total > 0" style="float:right;margin-top:10px" :layout="pageLayout" :total="total"
            :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="fetchData()" />
        </div>
        <div v-if="tabPosition==='未提交'" class="table-tree">
          <el-table :key="'未提交'" border class="table-pane" height="100%" :data="unSubmitList">
            <el-table-column prop="userName" label="姓名" />
            <el-table-column label="未提交日期" prop="dates" show-overflow-tooltip>
              <template slot-scope="{ row }">
                <el-tag v-for="date in row.$dateList" :key="date" type="danger" style="margin:4px 8px">
                  {{ date }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <Detail ref="detaipanel" />
    </div>
    <selectPrjListDlg ref="selectPrjListDlg" :select-prj-list="selectPrjList" @callback="afterPrjSelected"></selectPrjListDlg>
  </div>
</template>
<script>
import { mapState } from "vuex";
import manHourService from "@/CommonDP/service/work-time/man-hour-service";
import request from "@/CommonDP/service/sysServer-service";
import Pagination from "@/CommonDP/components/Pagination"; // Secondary package based on el-pagination
import selectPrjListDlg from "@/CommonDP/components/selectPrjListDlg";
import orgFrameworkConfig from "@/CommonDP/service/org-service";
import Detail from "./detail.vue";
import moment from "moment";

// 引入 ECharts
const echarts = require("echarts");
const defaultUnSubmitDates = [moment().weekday(0).format("YYYY-MM-DD"), moment().weekday(6).format("YYYY-MM-DD")];
const defaultUnSubmitQuery = {
  isWeekend: "1",
  projectID: undefined,
  pageIndex: 1,
  pageSize: 20,
  total: 0,
  deptIdList: [],
  checkedDate: [...defaultUnSubmitDates]
};
export default {
  name: "StatisticalAnalysis",
  components: { Pagination, Detail, selectPrjListDlg },
  data() {
    return {
      projectsList: [], // 项目列表
      usersList: [],
      hoursList: [], // 工时列表
      prjWorkTimeList: [], // 项目工作时长列表
      userWorkTimeList: {}, // 人员工作时长列表
      prjUserList: [], // 项目人数
      lineChartOrder: "", // 项目工作时长折线图
      columnsChartOrder: "", // 人员工作时长柱状图
      userCountChart: "", // 项目总人数柱状图
      pageLayout: "total, sizes, prev, pager, next, jumper", // 分页组件
      total: 0, // 总条数
      pickerOptions: {
        // 日期快捷设置
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      listQuery: {
        // 查询相关
        prjNameList: "",
        prjIdList: [],
        deptIdList: [],
        page: 1, // 当前页
        limit: 10, // 每页限制条数
        status: '2', // 模式，默认图表模式
        checkedProject: "", // 已选项目
        checkedUser: "",
        checkedDate: [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date()], // 已选日期数组（初始化默认日期为最近一月）
        startDate: "", // 开始日期
        endDate: "", // 结束日期
        searchInput: "" // 关键字
      },
      tabPosition: '已提交',
      unSubmitQuery: {
        ...defaultUnSubmitQuery,
        checkedDate: [...defaultUnSubmitDates]
      },
      unSubmitList: [], // 未提交列表
      depOptions: [],
      depDefaultProps: {
        children: "children",
        label: "deptName",
        value: "deptId",
        checkStrictly: true,
        multiple: true,
        emitPath: false,
        expandTrigger: 'hover'
      },
      selectPrjList: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.fetchData();
  },
  created() {
    this.queryTreeOrginfo();
  },
  methods: {
    afterPrjSelected(data) {
      this.selectPrjList = data;
      this.listQuery.prjNameList = data.map((ele) => ele.originalPrjName).join(",");
      this.listQuery.prjIdList = data.map(i => i.prjId);
    },
    openPrjDlg() {
      this.$refs.selectPrjListDlg.show();
    },
    changeTabPosition() {
      this.handleRefresh();
    },
    // 查询方法
    fetchData(sel) {
      this.timeSlot(this.listQuery.checkedDate);
      var params = {
        name: this.listQuery.checkedUser,
        startDate: this.listQuery.startDate,
        endDate: this.listQuery.endDate,
        enterpriseId: this.enterpriseId,
        prjIdList: this.listQuery.prjIdList,
        deptIdList: this.listQuery.deptIdList
      };
      if (this.listQuery.status === '1') {
        if (this.tabPosition === '已提交') {
          this.getUsersList(); // 获取人员列表
          // 列表模式
          this.getHoursList(params, this.listQuery.page, this.listQuery.limit, sel); // 默认加载工时统计数据列表
        } else {
          this.queryUnSubmitList();
        }
      } else if (this.listQuery.status === '2') {
        this.drawLineChart();
        this.drawColumnsChart();
        this.drawUserCountChart();
      }
    },
    queryTreeOrginfo() {
      return orgFrameworkConfig
        .getOrgTree(this.enterpriseId)
        .then(({ data }) => {
          this.depOptions = data;
        })
        .catch((e) => console.warn(e));
    },
    queryUnSubmitList() {
      if (!this.unSubmitQuery.checkedDate) {
        this.unSubmitQuery.checkedDate = [...defaultUnSubmitDates];
      }
      const {
        unSubmitQuery: {
          isWeekend,
          projectID,
          checkedDate: [startDate, endDate]
        },
        pageSize,
        pageNo
      } = this;
      const deptIdList = this.unSubmitQuery.deptIdList.map((ele) => ele).join(",");
      const params = {
        projectID,
        startDate,
        endDate,
        isWeekend,
        pageSize,
        pageNo,
        enterpriseId: this.enterpriseId,
        deptIdList
      };
      request.queryUserNoSubmitDate(params).then((res) => {
        this.unSubmitList = res.data;
        this.unSubmitList = res.data.map((row) => {
          const { dates } = row;
          row.$dateList = dates ? dates.split(",") : [];
          return row;
        });
        console.log(this.unSubmitList, 'this.unSubmitList');
      });
    },
    // 工时列表
    async getHoursList(params, pageNo, pageSize, sel) {
      console.log(sel);
      if (sel) {
        pageNo = 1;
      }
      var res = await request.getStatisticalHoursDataNew(params, pageNo, pageSize);
      if (res.result === "0") {
        this.hoursList = res.data;
        this.total = res.totalCount;
      } else {
        this.$message.error("查询失败");
      }
    },
    getPrjWorkTime() {
      this.prjWorkTimeList = [];
      this.timeSlot(this.listQuery.checkedDate);
      const params = {
        startDate: this.listQuery.startDate,
        endDate: this.listQuery.endDate,
        enterpriseId: this.enterpriseId,
        prjIdList: this.listQuery.prjIdList,
        deptIdList: this.listQuery.deptIdList
      };
      manHourService
        .getPrjWorkTimeData(params)
        .then((res) => {
          if (res.data.length > 0) {
            const workTimeArr = [];
            const prjList = [];
            for (var i = 0; i < res.data.length; i++) {
              workTimeArr.push(res.data[i].workTimeSum);
              prjList.push(res.data[i].projectName);
            }
            const a = {};
            a.type = "line";
            a.name = "项目工作时长";
            a.data = workTimeArr;
            a.itemStyle = {
              normal: {
                color: "#1790FF",
                label: {
                  show: true,
                  position: 'top'
                },
                lineStyle: {
                  color: "#1790FF"
                }
              }
            };
            this.prjWorkTimeList.push(a);
            console.log(this.prjWorkTimeList);
            this.lineChartOrder.setOption({
              tooltip: {
                trigger: "axis"
              },
              title: {
                text: "",
                subtext: "单位(h)",
                left: "100px"
              },
              legend: {
                data: ["项目工作时长"],
                x: "right",
                y: "top"
              },
              grid: {
                left: "8%",
                right: "4%",
                bottom: "3%",
                containLabel: true
              },

              yAxis: {
                type: "value"
              },
              xAxis: {
                type: "category",
                boundaryGap: false,
                data: prjList,
                axisLabel: {
                  rotate: 40,
                  interval: 0,
                  formatter: function (value) {
                    if (value.length > 4) {
                      return `${value.slice(0, 4)}...`;
                    }
                    return value;
                  }
                }
              },
              series: this.prjWorkTimeList
            });
          }
        })
        .then(() => {
          // this.$message.success('查询成功');
        });
    },
    getUserWorkTime() {
      this.userWorkTimeList = {};
      this.timeSlot(this.listQuery.checkedDate);
      const params = {
        startDate: this.listQuery.startDate,
        endDate: this.listQuery.endDate,
        enterpriseId: this.enterpriseId,
        prjIdList: this.listQuery.prjIdList,
        deptIdList: this.listQuery.deptIdList
      };
      manHourService
        .getUserWorkTimeData(params)
        .then((res) => {
          if (res.data.length > 0) {
            this.userWorkTimeList.dimensions = ["userName", "工作时长", "加班时长"];
            var tempArr = [];
            for (var i = 0; i < res.data.length; i++) {
              var obj = {};
              obj.userName = res.data[i].userName;
              obj.工作时长 = res.data[i].workTimeSum;
              obj.加班时长 = res.data[i].overTimeSum;
              tempArr.push(obj);
            }
            this.userWorkTimeList.source = tempArr;
            console.log(this.userWorkTimeList);
            this.columnsChartOrder.setOption({
              legend: {
                x: "right",
                y: "top"
              },
              title: {
                text: "",
                subtext: "单位(h)",
                left: "100px"
              },
              grid: {
                left: "8%",
                right: "4%",
                bottom: "3%",
                containLabel: true
              },
              tooltip: {},
              dataset: this.userWorkTimeList,
              xAxis: {
                type: "category",
                axisLabel: {
                  rotate: 40
                }
              },
              yAxis: {},

              series: [
                {
                  type: "bar",
                  barWidth: 15,
                  label: {
                    show: true,
                    position: 'top'
                  },
                  itemStyle: {
                    normal: {
                      color: "#1790FF"
                    }
                  }
                },
                {
                  type: "bar",
                  barWidth: 15,
                  label: {
                    show: true,
                    position: 'top'
                  },
                  itemStyle: {
                    normal: {
                      color: "#2FC15A"
                    }
                  }
                }
              ]
            });
          } else {
            this.columnsChartOrder.setOption({
              legend: {
                x: "right",
                y: "top"
              },
              title: {
                text: "",
                subtext: "单位(h)",
                left: "100px"
              },
              grid: {
                left: "8%",
                right: "4%",
                bottom: "3%",
                containLabel: true
              },
              tooltip: {},
              dataset: {
                dimensions: ["userName", "工作时长", "加班时长"],
                source: [{ username: "--" }, { 工作时长: 0 }, { 加班时长: 0 }]
              },
              xAxis: { type: "category" },
              yAxis: {},
              series: [
                {
                  type: "bar",
                  barWidth: 15,
                  label: {
                    show: true,
                    position: 'top'
                  },
                  itemStyle: {
                    normal: {
                      color: "#1790FF"
                    }
                  }
                },
                {
                  type: "bar",
                  barWidth: 15,
                  label: {
                    show: true,
                    position: 'top'
                  },
                  itemStyle: {
                    normal: {
                      color: "#2FC15A"
                    }
                  }
                }
              ]
            });
          }
        })
        .then(() => {
          // this.$message.success('查询成功');
        });
    },
    getPrjUser() {
      this.prjUserList = [];
      this.projectsList = [];
      this.timeSlot(this.listQuery.checkedDate);
      const params = {
        startDate: this.listQuery.startDate,
        endDate: this.listQuery.endDate,
        enterpriseId: this.enterpriseId,
        prjIdList: this.listQuery.prjIdList,
        deptIdList: this.listQuery.deptIdList
      };
      manHourService
        .getPrjUserData(params)
        .then((res) => {
          for (var i = 0; i < res.data.length; i++) {
            this.prjUserList.push(res.data[i].peopleNumber);
            this.projectsList.push(res.data[i].projectName);
          }
          const option = {
            tooltip: {},
            legend: {
              data: ["项目总人数"],
              x: "right",
              y: "top"
            },
            grid: {
              left: "1%",
              top: "8%",
              width: "100%",
              containLabel: true
            },
            xAxis: {
              type: "category",
              data: this.projectsList,
              axisLabel: {
                rotate: 40,
                interval: 0,
                formatter: function (value) {
                  if (value.length > 4) {
                    return `${value.slice(0, 4)}...`;
                  }
                  return value;
                }
              }
            },
            yAxis: {
              type: "value",
              minInterval: 1
            },
            dataZoom: [
              {
                startValue: 0,
                endValue: 9,
                zoomLock: false, // 锁定滑块大小
                handleSize: 6,
                showDetail: false, // 滑块两端信息
                showDataShadow: false, // 数据阴影可以简单地反应数据走势
                brushSelect: false,
                show: true,
                height: 6,
                right: 0,
                backgroundColor: "rgba(220, 220, 220, 0.3)", // 背景颜色
                borderColor: "rgb(0 0 0 0.3);", // 边框颜色
                fillerColor: "rgba(200, 200, 200, 0.88)", // 滑块颜色
                handleIcon: "circle", // 滑块两端圆形
                handleStyle: {
                  color: "rgba(200, 200, 200, 1)", // 滑块两端圆形颜色
                  borderWidth: 0
                }
              }
            ],
            series: [
              {
                name: "项目总人数",
                type: "bar",
                barWidth: 15,
                label: {
                  show: true,
                  position: 'top'
                },
                itemStyle: {
                  normal: {
                    color: "#1790FF"
                  }
                },
                data: this.prjUserList
              }
            ]
          };
          if (this.projectsList.length < 8) option.dataZoom = [];
          this.userCountChart.setOption(option, true);
        })
        .then(() => {
          // this.$message.success('查询成功');
        });
    },
    drawLineChart() {
      this.lineChartOrder = echarts.init(this.$refs.myChart1);
      this.getPrjWorkTime();
    },
    drawColumnsChart() {
      this.columnsChartOrder = echarts.init(this.$refs.myChart2);
      this.getUserWorkTime();
    },
    drawUserCountChart() {
      this.userCountChart = echarts.init(this.$refs.myChart3);
      this.getPrjUser();
    },
    // tabs切换
    handleTabClick(index) {
      this.selectPrjList = [];
      this.listQuery.prjNameList = "";
      this.listQuery.prjIdList = [];
      this.listQuery.deptIdList = [];
      this.listQuery.status = index;
      this.listQuery.checkedDate = [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date()];
      this.tabPosition = '已提交';
      this.fetchData();
    },
    // 筛选数据
    handleSieve(sel) {
      this.fetchData(sel);
    },
    // 刷新数据
    handleRefresh() {
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.selectPrjList = [];
      this.listQuery.prjNameList = "";
      this.listQuery.prjIdList = [];
      this.listQuery.deptIdList = [];
      this.listQuery.checkedProject = "";
      this.listQuery.checkedUser = "";
      this.listQuery.startDate = "";
      this.listQuery.endDate = "";
      if (this.tabPosition === '已提交') {
        this.listQuery.checkedDate = [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date()];
      } else {
        this.resetUnSubmitQuery();
      }
      this.fetchData();
    },
    resetUnSubmitQuery() {
      this.unSubmitQuery = {
        ...defaultUnSubmitQuery,
        checkedDate: [...defaultUnSubmitDates]
      };
    },
    // 人员列表
    getUsersList() {
      this.timeSlot(this.listQuery.checkedDate);
      manHourService.getPersonList(this.enterpriseId).then((res) => {
        console.log(res, "查询");
        this.usersList = res.data;
      });
    },
    // 日期格式化
    timeSlot(row, column) {
      if (row != null) {
        if (row instanceof Array) {
          this.listQuery.startDate = moment(this.listQuery.checkedDate[0]).format("YYYY-MM-DD 00:00:00");
          this.listQuery.endDate = moment(this.listQuery.checkedDate[1]).format("YYYY-MM-DD 23:59:59");
        }
      } else {
        this.listQuery.checkedDate = [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date()];
      }
    },

    async exportOffice() {
      this.timeSlot(this.listQuery.checkedDate);
      const { startDate, endDate, limit, page, checkedUser } = this.listQuery;
      const prjIdList = this.listQuery.prjIdList.map((ele) => ele).join(",");
      const deptIdList = this.listQuery.deptIdList.map((ele) => ele).join(",");

      const res = await manHourService.overviewExcel(startDate, endDate, 2, limit, page, checkedUser, this.enterpriseId, prjIdList, deptIdList);
      const fileName = '工时看板导出' + ".xlsx";
      if ("msSaveOrOpenBlob" in navigator) {
        // 兼容ie
        window.navigator.msSaveOrOpenBlob(res, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = res;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    async viewdetail(userinfo) {
      this.timeSlot(this.listQuery.checkedDate);
      var userId = userinfo.userID;
      var userName = userinfo.userName;

      var params = {
        startDate: this.listQuery.startDate,
        endDate: this.listQuery.endDate,
        operUserID: userId,
        enterpriseId: this.enterpriseId
      };
      var res = await manHourService.countDetail(params);
      if (res.result === "0") {
        this.$refs.detaipanel.showpanel(true, userName, res.data);
        console.log(userinfo);
      }
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#hoursStatistical {
  height: 100%;
  background: #eff1f6;
  padding: var(--middle-space);
  display: flex;
  flex-direction: column;
  .header {
    width: 100%;
    background-color: white;
    border-radius: 4px 4px 0 0;
    overflow: hidden;
    position: relative;

    .el-menu {
      padding-left: var(--big-space);
      border-bottom: 1px solid #e6eaf8;

      .el-menu-item {
        height: 46px;
        padding: 0;
        margin: 0 40px 0 0;

        font-family: "PingFang SC";
        font-weight: 700;
        font-size: 16px;
        line-height: 46px;
      }
    }
  }
  .contentBox {
    height: 1px;
    flex-grow: 1;
    background: #fff;
  }
  .content{
    height: 100%;
    padding: 0 var(--big-space) var(--middle-space);
    overflow: auto;
    display: flex;
    flex-direction: column;
    .search-pane{
      padding: var(--big-space) 0;
    }
    .label {
      margin-left: var(--middle-space);
    }
    .mr10 {
      margin-right: var(--middle-space);
    }
  }
  .container {
    background: #fff;
  }
  .iB {
    display: inline-block;
    position: relative;
  }
  .table-tree {
    height: 1px;
    flex-grow: 1;
    .el-table {
      width: 100%;
      height: 100%;
    }
    .el-table--group::after,
    .el-table::before {
      background-color: transparent;
    }
  }
  #myChart1,
  #myChart2,
  #myChart3 {
    margin-top: 40px;
    width: calc(100vw - 170px);
    height: 400px;
  }
}
.charts-list {
  width: 100%;
}
.charts-item {
  border: 1px solid #d4d9ec;
  margin-bottom: var(--big-space);
  position: relative;
  .charts-title {
    position: absolute;
    text-align: center;
    font-weight: bold;
    top: 0px;
    left: 20px;
    margin-top: var(--big-space);
  }
}
.viewdetail {
  cursor: pointer;
  color: #3289f0;
}
</style>
